import React from 'react';
import './Contact.css';
import ClientReviews from "./ClientReviews";

const Contact = () => {
  return (
    
    <div style={{ marginTop: '10%' }}>
      <div>
      <ClientReviews />
    </div>
      {/* Custom Form Container */}
      <div className="custom-form-container" style={{ height: 'fit-content' }}>
        {/* Left Form Section */}
        <div className="custom-form-left">
          <form>
            <label htmlFor="custom-name">Name*</label>
            <input type="text" id="custom-name" placeholder="" required />

            <label htmlFor="custom-phone">Phone*</label>
            <input type="text" id="custom-phone" placeholder="" required />

            <label htmlFor="custom-message">Comment Or Message*</label>
            <input type="text" id="custom-message" placeholder="" required />

            <button type="submit" className="custom-submit-btn" style={{ marginTop: '5%', height: '40px', border: '1px solid black' }}>
              SUBMIT
            </button>
          </form>
        </div>

        {/* Right Form Section */}
        <div className="custom-form-right" style={{ backgroundColor: 'white' }}>
          <h2 style={{ color: '#00A9B7', marginTop: '10%', marginLeft: '10%' }}>
            Lets Complete This
            <br /> Form To Get
            <br /> Custom Offer
            <p style={{ textAlign: 'left', marginTop: '4%' }}>
              Input your query about anything
              <br /> related to our products and it will be
              <br /> resolved within the next 24 hours.
            </p>
          </h2>
        </div>
      </div>

      {/* Footer Section */}
      <footer className="custom-footer">
        <div className="custom-footer-container">
          {/* About Section */}
          <div className="custom-footer-section">
            <h3 style={{ color: 'black', textAlign: 'left' }}>Sawla Stone Industries</h3>
            <p style={{ textAlign: 'left' }}>
              The advantage of hiring a workspace
              <br /> with us is that it gives you comfortable
              <br /> service and all-around facilities.
            </p>
          </div>

          {/* Types of Stones Section */}
          <div className="custom-footer-section">
            <h3 style={{ textAlign: 'left' }}>Types of Kota Stones</h3>
            <p style={{ textAlign: 'left' }}>
              <i>Kota Stone Blue</i>
            </p>
            <p style={{ textAlign: 'left' }}>
              <i>Kota Stone Brown</i>
            </p>
            <p style={{ textAlign: 'left' }}>
              <i>Red Mandana Stone</i>
            </p>
            <p style={{ textAlign: 'left' }}>
              <i>Kota Stone Tiles</i>
            </p>
          </div>

          {/* Contact Us Section */}
          <div className="custom-footer-section">
            <h3 style={{ textAlign: 'left' }}>Contact Us</h3>
            <p style={{ textAlign: 'left' }}>
              <b>07459-220690</b>
            </p>
            <p style={{ textAlign: 'left' }}>+91 98290 39690</p>
            <p style={{ textAlign: 'left' }}>+91 97992 35966</p>
            <p style={{ textAlign: 'left' }}>sawlastoneindustries@gmail.com</p>
          </div>

          {/* Locate Us Section */}
          <div className="custom-footer-section">
            <h3 style={{ textAlign: 'left' }}>Locate Us</h3>
            <p style={{ textAlign: 'left' }}>
              <b>Site Address:</b> Industrial Area, Kudayala, Ramganjmandi, Kota, Rajasthan-326519
            </p>
            <p style={{ textAlign: 'left' }}>
              <b>Office Address:</b> Bazar No.1, Near Railway Station, Ramganjmandi, Kota, Rajasthan-326519
            </p>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="custom-footer-bottom">
          <p>Copyright © 2021</p>
          <p>Terms & Conditions | Privacy Policy</p>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
